// Icons import
/*
import scansIcon from "../../assets/images/kb/scans-icon.svg";
import remediationIcon from "../../assets/images/kb/remediation-icon.svg";
import platformIcon from "../../assets/images/kb/platform-icon.svg";
import faqIcon from "../../assets/images/kb/faq-icon.svg";
import troubleshootingIcon from "../../assets/images/kb/troubleshooting-icon.svg";
import releaseNotesIcon from "../../assets/images/kb/release-notes-icon.svg";
import glossaryIcon from "../../assets/images/kb/glossary-icon.svg";
*/

import scansIcon from "../../../assets/images/Identify_Valkyrie.svg";
import remediationIcon from "../../../assets/images/Identify_Valkyrie.svg";
import platformIcon from "../../../assets/images/Identify_Valkyrie.svg";
import faqIcon from "../../../assets/images/Identify_Valkyrie.svg";
//import troubleshootingIcon from "../../../assets/images/Identify_Valkyrie.svg";
import releaseNotesIcon from "../../../assets/images/Identify_Valkyrie.svg";
import glossaryIcon from "../../../assets/images/Identify_Valkyrie.svg";

// Import subcategory data
import { scansSubcategories } from "./scans";
import { remediationSubcategories } from "./remediation";
import { platformSubcategories } from "./platform";

export const categoryData = {
  "scans": {
    id: "scans",
    title: "Scans Explained",
    icon: scansIcon,
    subcategories: scansSubcategories
  },
  "remediation": {
    id: "remediation",
    title: "Remediation / Mitigation",
    icon: remediationIcon,
    subcategories: remediationSubcategories
  },
  "platform": {
    id: "platform",
    title: "Platform & Tools",
    icon: platformIcon,
    subcategories: platformSubcategories
  },
  "faq": {
    id: "faq",
    title: "FAQ",
    icon: faqIcon,
    contentPath: "faq"
  },
  //"troubleshoot": {
    //id: "troubleshoot",
    //title: "Troubleshooting",
    //icon: troubleshootingIcon,
    //contentPath: "troubleshooting"
  //},
  "release-notes": {
    id: "release-notes",
    title: "Release Notes",
    icon: releaseNotesIcon,
    contentPath: "release-notes"
  },

  "glossary": {
    id: "glossary",
    title: "Glossary",
    icon: glossaryIcon,
    contentPath: "glossary"
  }
};